import React from "react";

import SystemSettingFeature from "../features/admin/systemSetting";

function SystemSettingComp(props) {
  return <SystemSettingFeature {...props} />;
}

export default SystemSettingComp;
